/**
 *
 * @param {object} obj
 * @param {string} key
 * @returns
 */
function hasKey(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

export default hasKey;
